import React from 'react'
import { business } from '../../Images'
import css from './HomePage.module.scss'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { battery_blank, battery_charged } from '../../Images/Icons'

const GridEnergyBusiness = (props) => {

    return (
        <div className={css.grid_business}>
            <div className={css.image} style={{ position: 'relative' }}>
                <img src={business} />
            </div>
            <div className={css.home_value2}>
                <div>PV</div>
                <div>
                    <label>{props.data.return.pv.active_power.toFixed(2)}</label>
                    <span> kW</span>
                </div>
            </div>
            <div className={css.home_value3}>
                <div>Consumption</div>
                <div>
                    <label>{props.data.return.consumption.total.toFixed(2)}</label>
                    <span> kW</span>
                </div>
            </div>
            <div className={css.home_value4}>
                <div>Grid</div>
                <div>
                    <label>{props.data.return.grid.power.toFixed(2)}</label>
                    <span> kW</span>
                </div>
            </div>
        </div>
    )
}

export default GridEnergyBusiness